
import { useState, useEffect } from "react";
import { GalleryImage } from "@/components/index/gallery/galleryData";
import { 
  getAllGalleryImages,
  getGalleryImageByIndex,
  getGalleryImageById,
  getGalleryImagesByCategory,
  getGalleryCategories
} from "@/services/galleryService";

export const useAllGalleryImages = () => {
  const [images, setImages] = useState<GalleryImage[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchImages = async () => {
      setLoading(true);
      const response = await getAllGalleryImages();
      
      if (response.error) {
        setError(response.error);
      } else {
        setImages(response.data);
        setError(null);
      }
      
      setLoading(false);
    };

    fetchImages();
  }, []);

  return { images, loading, error };
};

export const useGalleryImage = (index: number) => {
  const [image, setImage] = useState<GalleryImage | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchImage = async () => {
      setLoading(true);
      const response = await getGalleryImageByIndex(index);
      
      if (response.error) {
        setError(response.error);
      } else {
        setImage(response.data);
        setError(null);
      }
      
      setLoading(false);
    };

    fetchImage();
  }, [index]);

  return { image, loading, error };
};

export const useGalleryImageById = (id: string | undefined) => {
  const [image, setImage] = useState<GalleryImage | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchImage = async () => {
      if (!id) {
        setError("Image ID is required");
        setLoading(false);
        return;
      }
      
      setLoading(true);
      const response = await getGalleryImageById(id);
      
      if (response.error) {
        setError(response.error);
      } else {
        setImage(response.data);
        setError(null);
      }
      
      setLoading(false);
    };

    fetchImage();
  }, [id]);

  return { image, loading, error };
};

export const useGalleryImagesByCategory = (category: string) => {
  const [images, setImages] = useState<GalleryImage[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchImages = async () => {
      setLoading(true);
      const response = await getGalleryImagesByCategory(category);
      
      if (response.error) {
        setError(response.error);
      } else {
        setImages(response.data);
        setError(null);
      }
      
      setLoading(false);
    };

    fetchImages();
  }, [category]);

  return { images, loading, error };
};

export const useGalleryCategories = () => {
  const [categories, setCategories] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCategories = async () => {
      setLoading(true);
      const response = await getGalleryCategories();
      
      if (response.error) {
        setError(response.error);
      } else {
        setCategories(response.data);
        setError(null);
      }
      
      setLoading(false);
    };

    fetchCategories();
  }, []);

  return { categories, loading, error };
};
